export default (theme) => ({
	backgroundMain: {
		padding: "24px 40px",
		marginBottom: 16,
		[theme.breakpoints.down("xs")]: {
			padding: "16px 24px",
		},
	},
	profileMain: {
		"paddingRight": "8%",
		[theme.breakpoints.down("sm")]: {
			paddingRight: 0,
		},
		"& li": {
			lineHeight: 1.6,
			marginBottom: 12,
		},
	},
	reviewsDialog: {
		"& li": {
			lineHeight: 1.6,
			marginBottom: 12,
		},
	},
	profilePhotoImg: {
		width: 160,
		height: 160,
		[theme.breakpoints.down("xs")]: {
			width: 100,
			height: 100,
		},
	},
	profileH1: {
		"fontSize": 30,
		"lineHeight": "36px",
		"fontWeight": 700,
		"margin": 0,
		"wordBreak": "break-word",
		"-webkit-box-orient": "vertical",
		"-webkit-line-clamp": 2,
		[theme.breakpoints.down("xl")]: {
			fontSize: 30,
			lineHeight: "36px",
		},
		[theme.breakpoints.down("md")]: {
			fontSize: 26,
			lineHeight: "32px",
		},
		[theme.breakpoints.down("sm")]: {
			"fontSize": 24,
			"lineHeight": "30px",
			"-webkit-line-clamp": 3,
		},
		[theme.breakpoints.down("xs")]: {
			"fontSize": 22,
			"-webkit-line-clamp": 3,
		},
	},
	profileLocation: {
		fontSize: 16,
		fontWeight: 600,
		[theme.breakpoints.down("sm")]: {
			fontSize: 14,
		},
	},
	profileH2: {
		marginTop: 20,
		marginBottom: 16,
		fontWeight: "600",
		fontSize: 22,
		[theme.breakpoints.down("sm")]: {
			//fontSize: 18,
		},
	},
	profileBodyText: {
		fontSize: 16,
		lineHeight: 1.6,
		//	[theme.breakpoints.down("xs")]: {
		//fontSize: 14,
		//lineHeight: 1.6,
		//},
	},
	profileAboutCollapse: {
		"&:before": {
			position: "absolute",
			height: 200,
			width: "100%",
			content: `""`,
			background:
				"linear-gradient(to top, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 35%)",
			pointerEvents: "none",
		},
	},
	profileReviewText: {
		marginTop: 4,
	},
	profileReviewDate: {
		fontSize: 14,
		marginBottom: 16,
		[theme.breakpoints.down("xs")]: {
			fontSize: 12,
		},
	},
	reviewPhotos: {
		"overflowX": "hidden",
		"-webkit-overflow-scrolling": "touch",
	},
	reviewPhotosImg: {
		"width": 64,
		"height": 64,
		"marginRight": 10,
		"overflow": "hidden",
		"&:hover": {
			opacity: "0.8",
		},
	},
	reviewDivider: {
		paddingTop: 24,
		paddingBottom: 24,
	},

	projectPhoto: {
		"height": "100%",
		"width": "100%",
		"&:hover": {
			opacity: "0.8",
		},
	},
	projectText: {
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
	},
	profileH3: {
		fontSize: 17,
		fontWeight: 600,
		marginBottom: 12,
		[theme.breakpoints.down("xs")]: {
			//fontSize: 16,
		},
	},
	flexBasis: {
		flexBasis: "49%",
		[theme.breakpoints.down("xs")]: {
			flexBasis: "48%",
		},
	},
	serviceChips: {
		"display": "flex",
		"flexWrap": "wrap",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
	chipGreen: {
		color: "#0d8d33",
		backgroundColor: "#e2f9e9",
	},
	iconGreen: {
		color: "#0d8d33",
	},
	chipPurple: {
		color: "#0535bc",
		backgroundColor: "#e7eaff",
		cursor: "pointer",
	},
	iconPurple: {
		color: "#0535bc",
	},
	chipBlue: {
		color: "#0b05bc",
		backgroundColor: "#e7f4ff",
	},
	iconBlue: {
		color: "#0b05bc",
	},
	iconStar: {
		color: "#ff6474",
	},
	buttonCTA: {
		height: 50,
		padding: "8px 24px",
	},
	showAllButton: {
		height: 50,
		[theme.breakpoints.down("xs")]: {
			width: "100%",
		},
	},
	leadPanelBox: {
		border: "1px solid rgb(221, 221, 221)",
		boxShadow: "rgba(0, 0, 0, 0.12) 0px 6px 16px",
		padding: 24,
		position: "sticky",
		borderRadius: 12,
		top: 36,
		right: 0,
		marginTop: 20,
		[theme.breakpoints.down("sm")]: {
			marginBottom: 30,
		},
	},
	leadPanelBoxMobile: {
		[theme.breakpoints.down("xs")]: {
			border: "unset",
			boxShadow: "unset",
			padding: "unset",
			position: "relative",
			borderRadius: "unset",
			top: "unset",
			right: "unset",
			marginTop: 20,
		},
	},
	leadPanelBoxHeight: {
		position: "relative",
		minHeight: 200,
		[theme.breakpoints.down("xs")]: {
			minHeight: 330,
		},
	},
	profileActionsText: {
		"display": "-webkit-box",
		"overflow": "hidden",
		"textOverflow": "ellipsis",
		"-webkit-box-orient": "vertical",
		"-webkit-line-clamp": 8,
		"maxHeight": 210,
		[theme.breakpoints.down("xs")]: {
			"-webkit-line-clamp": 3,
		},
	},
	profileReviewBox: {
		paddingBottom: 24,
	},
	reviewReplyTitle: {
		fontWeight: 600,
	},

	profileTextGrey: {
		color: theme.palette.grey[700],
	},
	profileServicesText: {
		fontSize: 16,
		lineHeight: 1.6,
		[theme.breakpoints.down("xs")]: {
			fontSize: 14,
		},
	},
	profileDivider: {
		paddingTop: 20,
		paddingBottom: 20,
	},
	profileQABox: {
		marginBottom: 32,
	},
	profileResumeTitle: {
		lineHeight: 1.6,
	},
	profileResumeH3: {
		fontSize: 18,
		fontWeight: 600,
		marginBottom: 32,
		marginTop: 0,
	},
	profileResumeDetail: {
		fontSize: 14,
		color: theme.palette.grey[700],
		lineHeight: 1.6,
	},
	profileResumeBorder: {
		borderBottom: "1px dashed #eaeaea",
		paddingBottom: 40,
		marginBottom: 24,
	},
	profileCredential: {
		display: "flex",
		alignItems: "center",
		marginBottom: 4,
	},
	profileCredentialIcon: {
		width: 20,
		height: 20,
	},
	iconSuccess: {
		color: theme.palette.success.main,
	},
	detailsHead: {
		fontWeight: 600,
		marginBottom: 12,
	},
	profileCredentialText: {
		marginLeft: 12,
		lineHeight: 1,
	},
	profileDetailsText: {
		marginLeft: 12,
		lineHeight: 1.4,
		marginRight: 4,
	},
	profileChip: {
		display: "flex",
		alignItems: "center",
		marginTop: 6,
		marginRight: 6,
	},
	proReviewsStatus: {
		fontSize: 14,
		fontWeight: 600,
		marginRight: 4,
		marginLeft: 6,
	},
	photoListItem: {
		marginBottom: "0px !important",
	},
	photoDialogPic: {
		"cursor": "pointer",
		"color": "transparent",
		"width": "100%",
		"height": "100%",
		"objectFit": "cover",
		"textAlign": "center",
		"&:hover": {
			opacity: "0.8",
		},
	},
	footerLink: {
		fontSize: 14,
	},
	faqQuestion: {
		fontSize: 18,
		lineHeight: 1.5,
		fontWeight: 600,
		marginBottom: 0,
		marginTop: 0,
		[theme.breakpoints.down("xs")]: {
			fontSize: 16,
		},
	},
	faqAnswer: {
		"fontSize": 16,
		"lineHeight": 1.6,
		"color": theme.palette.grey[700],
		[theme.breakpoints.down("xs")]: {
			//fontSize: 14,
		},
		"& p": {
			"&:last-child": {
				margin: 0,
			},
		},
	},
	accordionRoot: {
		"boxShadow": "unset !important",
		"borderBottom": "1px solid #f0f0f0 !important",
		"&:before": {
			height: "0px !important",
		},
		"&:last-child": {
			borderBottom: "0px !important",
		},
	},
	accordionSRoot: {
		padding: "0 !important",
	},
	accordionSContent: {
		margin: "24px 0px !important",
	},
	accordionDetailsRoot: {
		padding: "0px 0px 36px !important",
	},
	profileNav: {
		"position": "sticky",
		"background": "#FFF",
		"top": 0,
		"zIndex": 2,
		"overflowY": "auto",
		"borderBottom": "1px solid rgb(0 0 0 / 8%)",
		//"borderTop": "1px solid rgb(0 0 0 / 8%)",
		"& a": {
			paddingRight: 24,
			fontWeight: 600,
			fontSize: 14,
		},
		"& a.active": {
			fontWeight: 700,
		},
	},
	intro: {
		flexWrap: "wrap",
		wordWrap: "break-word",
		whiteSpace: "pre-wrap",
	},
	showMore: {
		fontWeight: 600,
		textDecoration: "underline",
	},
	iconZip: {
		color: "rgba(0, 0, 0, 0.40) !important",
	},
	hoursButton: {
		color: "#222222",
		width: "100%",
		display: "block",
		borderRadius: 6,
	},
	hoursDialogDay: {
		padding: "6px 0 6px 0",
		fontWeight: 600,
	},
	hoursDialogTime: {
		padding: "6px 0 6px 0",
	},
	licensePaper: {
		height: "100%",
		padding: 28,
	},
	licenseHead: {
		display: "flex",
		alignItems: "center",
		marginBottom: 16,
	},
	licenseTitle: {
		marginLeft: 4,
		fontWeight: 700,
	},
	licenseIcon: {
		color: theme.palette.success.main,
	},
	licenseFact: {
		"marginBottom": 8,
		"& span": {
			fontWeight: 600,
		},
	},
	proDetailsIcon: {
		fontSize: 26,
		color: "#949494",
	},
});
